module.exports = __webpack_public_path__ + "img/project1_medium@2x.09e31583.webp";